/**
 * Shared custom axis tick for multi-line Hebrew labels in Recharts bar charts.
 * Splits long labels on '–', '/', or space boundaries for better readability.
 */
export default function CustomizedAxisTick(props: any) {
    const { x, y, payload } = props;
    const text = payload.value;

    let lines: string[] = [];
    if (text.includes('–')) {
        lines = text.split('–').map((s: string, i: number) =>
            i === 0 ? s.trim() : '– ' + s.trim()
        );
    } else if (text.includes('/')) {
        lines = text.split('/').map((s: string, i: number) =>
            i === 0 ? s : '/' + s
        );
    } else {
        const words = text.split(' ');
        if (words.length > 1) {
            const mid = Math.ceil(words.length / 2);
            lines = [words.slice(0, mid).join(' '), words.slice(mid).join(' ')];
        } else {
            lines = [text];
        }
    }

    return (
        <g transform={`translate(${x},${y})`}>
            <text x={0} y={0} dy={32} textAnchor="middle" fill="#5c5549" fontSize={10}>
                {lines.map((line: string, index: number) => (
                    <tspan key={index} x={0} dy={index === 0 ? 0 : 12}>
                        {line}
                    </tspan>
                ))}
            </text>
        </g>
    );
}
